<template>
  <div class="email-app-details" v-if="Object.keys(emailViewData).length">
    <div class="email-detail-header">
      <div class="email-header-left d-flex align-items-center">
        <span class="go-back mr-50">
          <feather-icon
            :icon="
              $store.state.appConfig.isRTL
                ? 'ChevronLeftIcon'
                : 'ChevronRightIcon'
            "
            size="20"
            class="align-bottom"
            @click="closeEmailView()"
          />
        </span>
        <h4 class="email-subject mb-0">
          {{ emailViewData.data.subject }}
        </h4>
      </div>
    </div>

    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="email-scroll-area scroll-area"
    >
      <b-row>
        <b-col cols="12">
          <div class="email-label">
            <b-badge
              v-for="(relation, key, index) in emailViewData.data.relations"
              :key="index"
              pill
              class="text-capitalize mr-50 p-50"
              :variant="`light-${
                key == 'course'
                  ? 'warning'
                  : key == 'semester'
                  ? 'primary'
                  : 'info'
              }`"
            >
              {{
                key == "course" ? "دوره" : key == "semester" ? "ترم" : "جلسه"
              }}
              :
              {{ relation.title }}
            </b-badge>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <email-message-card :message="emailViewData" />
        </b-col>
      </b-row>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BBadge,
  BCard,
  BLink,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import EmailMessageCard from "./EmailMessageCard.vue";

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BBadge,
    BCard,
    BLink,
    VuePerfectScrollbar,
    EmailMessageCard,
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
    };
  },
  props: {
    emailViewData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closeEmailView() {
      this.$emit("close-email-view");
      this.$store.dispatch('appConfig/getEmailViewData', {})

    },
  },
};
</script>

<style></style>
